var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timestamp)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"caption"},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.includeDot && "• " || "")+_vm._s(_vm.formatTimeAgo(_vm.timestamp))+" ")])]}}],null,false,3644037479)},[_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm.formatDate(_vm.timestamp)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }